import type { App } from '../app/App';
import { SettingsPopup } from '../game/views/popups/settings/SettingsPopups';
import { exitToMainMenu } from './exitToMainMenu';
import type { RetryFlowConfig } from './failFlow/startRetryFlow';
import { startRetryFlow } from './failFlow/startRetryFlow';

export interface ShowSettingsMenuOptions {
  retryFlowConfig?: RetryFlowConfig;
  onLanguageChanged?: () => void;
}

export function showSettingsMenu(app: App, options?: ShowSettingsMenuOptions): void {
  const { popups } = app.controller;

  if (popups.hasActivePopup(SettingsPopup)) return;

  void popups.addPopup({
    popupConstructor: SettingsPopup,
    data: {
      app,
      showHomeButton: !!options?.retryFlowConfig,
      onLanguageChanged: options?.onLanguageChanged,
    },
    onEvent: async (event: string): Promise<void> => {
      if (event === 'close') {
        await popups.closeActivePopup(true);
      } else if (event === 'exitToMainMenu') {
        await popups.closeActivePopup(true);
        exitToMainMenu(app);
      } else if (event === 'languageChanged') {
        options?.onLanguageChanged?.();
      } else if (event === 'retry' && options?.retryFlowConfig) {
        void popups.closeActivePopup();
        void startRetryFlow(app, options.retryFlowConfig);
      }
    },
  });
}
